module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_11-56b9a7b121b6ced5b0b6a66642429db1.jpg";